const rateToPercentChange = (rate: number) => {
  return (rate * 100).toFixed(2) + '%'
}

/**
 * Maps the raw StockMonitor/GetMonitor rows to table rows for the given tab.
 * The API returns the full dataset for every product type, so switching tabs
 * only needs a client-side re-filter of the already fetched data.
 */
export const buildMonitorTableData = (data: any, tabIndex: number) => {
  let newData = data.map((row: any) => ({
    ...row,
    pendingOrderQuantity: row.productInventoryInfo.pendingOrderQuantity,
    pendingWorkOrderQuantity: row.productInventoryInfo.pendingWorkOrderQuantity,
    productInStock: row.productInventoryInfo.productInStock,
    productMsl: row.productInventoryInfo.productMsl,
    suggestedQuantity: row.productInventoryInfo.suggestedQuantity,
    pendingOrder: row.productInventoryInfo.pendingOrderQuantity,
    rate: rateToPercentChange(row.changeRate),
  }))
  newData = newData.filter((rowData: any) => rowData.type === tabIndex)
  // add trim to product name
  newData = newData.map((rowData: any) => {
    return {
      ...rowData,
      productName: rowData.productName.trim(),
    }
  })
  // sort by product name
  newData = newData.sort((a: any, b: any) => a.productName.localeCompare(b.productName))
  return newData
}
